export const DEFAULT_SNAPSHOT_RETRY_MS = 3000;

export function isSnapshotBuilding(payload) {
  return payload?.state === 'building';
}

export function snapshotRetryDelayMs(payload) {
  const retryAfter = Number(payload?.retry_after);
  return Math.max(
    1000,
    (Number.isFinite(retryAfter) ? retryAfter : DEFAULT_SNAPSHOT_RETRY_MS / 1000) * 1000,
  );
}
